'use client';

import { WistiaPlayer } from '@wistia/wistia-player-react';
import { useMonitoring } from '@/hooks/useMonitoring';
import { useRef } from 'react';

interface WistiaVideoProps {
  mediaId: string;
  className?: string;
}

export default function WistiaVideo({ mediaId, className = '' }: WistiaVideoProps) {
  const { trackClarityEvent, isConsentGiven } = useMonitoring();
  const hasTrackedPlay = useRef(false);

  const handlePlay = () => {
    // Only track once per video instance
    if (!hasTrackedPlay.current) {
      trackClarityEvent('video_started');
      hasTrackedPlay.current = true;
    }
  };

  return (
    <div className={className}>
      <WistiaPlayer
        mediaId={mediaId}
        playerColor="438cef"
        doNotTrack={!isConsentGiven}
        aspect={1.7777777777777777}
        onPlay={handlePlay}
      />
    </div>
  );
}